module.exports = __webpack_public_path__ + "categorybreadcrumbicon.ce9dabe3.svg";